








import { Component, Mixins, Prop } from "vue-property-decorator";
import { TextBoxInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import { DisableableMixin } from "../../../system/mixins";
import TextBoxWrapperObject from "../objects/TextBoxWrapperObject.vue";
import TextBoxInputMethodEditor from "../inputMethodEditors/TextBoxInputMethodEditor.vue";

@Component({
  components: {
    TextBoxInputMethodEditor,
  }
})
export default class TextBoxBehaviorEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: TextBoxWrapperObject;

  get isVisible(): boolean {
    return this.source.inputMethodOptionKind !== TextBoxInputMethodOptionKinds.Normal;
  }
}
